"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickablePicture = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const button_1 = require("../button");
const picture_style_1 = __importDefault(require("./picture.style"));
class ClickablePicture extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, onClick, img, editMode } = this.props;
            const imgObj = jsx_runtime_1.jsx("img", { src: img, alt: "", className: classes.picture }, void 0);
            if (editMode) {
                return imgObj;
            }
            return (jsx_runtime_1.jsxs(button_1.Button, Object.assign({ classes: classes, className: classes.pictureWrapper, onClick: onClick }, { children: [imgObj, jsx_runtime_1.jsx("div", Object.assign({ className: classes.caption }, { children: this.props.changeLabel }), void 0)] }), void 0));
        };
    }
}
exports.ClickablePicture = ClickablePicture;
ClickablePicture.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    img: prop_types_1.default.string.isRequired,
    editMode: prop_types_1.default.bool.isRequired,
    changeLabel: prop_types_1.default.node
};
ClickablePicture.defaultProps = {
    changeLabel: 'change'
};
exports.default = react_jss_1.default(picture_style_1.default)(ClickablePicture);
//# sourceMappingURL=index.js.map